import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get } from '~/actions/locations';
import Title from '~/components/Title';
import Tag from '~/components/Tag';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      stockPage: 1,
    };
  }

  componentDidMount() {
    get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(() => this.setState({ loading: false }));
  }

  renderDialog() {
    const { location } = this.props;
    const articleStock = Object.values(this.props.articleStock);
    const rawMaterialStock = Object.values(this.props.rawMaterialStock);

    return (
      <div>
        <Button
          style={{ float: 'right' }} label="Edit details" className={style.buttonEdit}
          onClick={() => this.context.dialogPush('locationEdit', { id: location.id })}
        />
        <Title style={{ marginBottom: '10px' }}>Information</Title>
        <div>Location #{location.sku}</div>
        <div>Name: {location.name}</div>
        {articleStock.length !== 0 && <div className={style.range}>
          <Button
            primary
            icon="chevron_left"
            onClick={() => this.setState({ stockPage: this.state.stockPage - 1 })}
            disabled={this.state.stockPage < 2}
          />
          &nbsp;{this.state.stockPage}/{Math.ceil(articleStock.length / 10)}&nbsp;
          <Button
            primary
            icon="chevron_right"
            onClick={() => this.setState({ stockPage: this.state.stockPage + 1 })}
            disabled={this.state.stockPage >= Math.ceil(articleStock.length / 10)}
          />
        </div>}
        <Title style={{ margin: '10px 0' }}>Stock</Title>
        {articleStock.slice((this.state.stockPage - 1) * 10,
          this.state.stockPage * 10).map(stock => (
            <div key={stock.articleId} className={style.stockRow}>
              <div className={style.title}>
                <Tag id={stock.articleId} type="article" />
              </div>
              <div className={style.count}>{stock.count}</div>
            </div>
          ))}
        {articleStock.length === 0 && <div>No articles in stock</div>}

        <Title style={{ margin: '10px 0' }}>Raw Material Stock</Title>
        {rawMaterialStock.slice((this.state.stockPage - 1) * 10,
          this.state.stockPage * 10).map(s => (
            <div key={s.rawMaterialId} className={style.stockRow}>
              <div className={style.title}>
                <Tag id={s.rawMaterialId} type="rawMaterial" />
              </div>
              <div className={style.count}>{s.count}</div>
            </div>
          ))}
        {rawMaterialStock.length === 0 && <div>No raw materials in stock</div>}

        {location.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.state.loading && 'Loading'}
            {!this.state.loading && !this.props.location && '404'}
            {!this.state.loading && this.props.location && this.renderDialog()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    location: state.getIn(['locations', 'locations', props.data.id]) && state.getIn(['locations', 'locations', props.data.id]).toJS(),
    articleStock: state.getIn(['stock', 'items']).filter(i => i.getIn(['location', 'id']) === props.data.id).toJS(),
    rawMaterialStock: state.getIn(['rawMaterialStock', 'items']).filter(i => i.getIn(['location', 'id']) === props.data.id).toJS(),
  };
};

export default connect(mapStateToProps)(Dialog);




// WEBPACK FOOTER //
// ./app/dialogs/Location/index.js